"use client";

import { useMutation } from "@tanstack/react-query";

import type {
  BrandResetPasswordRequest,
  BrandSendSmsRequest,
  BrandVerifySmsRequest,
} from "@/shared/api/services/authService";

import { useAuthService } from "@/features/auth/hooks/useAuthService";

export function useSendBrandSms() {
  const authService = useAuthService();

  return useMutation({
    mutationFn: async (data: BrandSendSmsRequest) => authService.sendBrandSms(data),
  });
}

export function useVerifyBrandSms() {
  const authService = useAuthService();

  return useMutation({
    mutationFn: async (data: BrandVerifySmsRequest) => authService.verifyBrandSms(data),
  });
}

export function useResetBrandPassword() {
  const authService = useAuthService();

  return useMutation({
    mutationFn: async (data: BrandResetPasswordRequest) => authService.resetBrandPassword(data),
  });
}
